<template>
  <td v-html="permissions"></td>
</template>

<script>
export default {
  props: ["content"],
  computed: {
    permissions() {
      let permissions = [];
      this.$attrs.model.roles.forEach(function(role) {
        role.permissions.forEach(function(permission) {
          permissions.push(permission.name);
        });
      });
      this.content.forEach(function(permission) {
        permissions.push(permission.name);
      });
      return permissions.join("<br>");
    }
  }
};
</script>
